<template>
  <div class="content">
    <card title="参观培训" styles="margin-top:24px">
      <div class="card_content" v-if="curShowNum == 5">
        <div class="item_list fb" v-if="renderShow">
          <div class="item box_style fs" v-for="(item, index) in listData" :key="index">
            <div class="icon">
              <img :src="`${require(`@/assets/hs/${item.icon}.png`)}`" alt="" class="Img" />
            </div>
            <div class="info">
              <p class="value light" v-if="item.code == 'frontWaterLevel'">
                {{ Math.floor(item.value * 1000) / 1000 }}
              </p>
              <p class="value light" v-else>{{ formartNumber(item.value) }}</p>
              <p class="name">{{ item.name }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="card_visit box_style" v-else>
        <p class="name">当前位置：{{ curInfo.name }}</p>
        <div class="view_box">
          <img
            src="http://test1.i3yoo.cn/cims/upload/i3yoo/N2023112922424859337713.jpg"
            alt=""
            class="Img"
            style="width: 100%; height: 100%"
          />
        </div>
        <p class="info">
          {{ curInfo.text }}
        </p>
      </div>
    </card>
  </div>
</template>

<script>
import Card from '@/components/Card.vue';
const dataConfig = {
  1: {
    name: '高板岩水库',
    pic: 'http://172.30.100.201:8000/prd200000/upload/20231122/befbdfb7b17b80a95a0cf4aaf21896c1.jpg',
    text: '水库拦河坝为浆砌石单曲拱坝，坝顶高程 532.40m，坝底高程 496.30m',
  },
  2: {
    name: '高板岩一站',
    pic: 'http://172.30.100.201:8000/prd200000/upload/20231122/b3e41a65b6fd2368bc73ae781e3f0167.jpg',
    text: '高板岩一级水电站位于霍山县西南大别山区东淠河支流桃源河上，坝址位于高板岩一级电站上游约 0.26km 处，拦河坝为浆砌石单曲拱坝，坝高 36.10m，溢流顶高 33m，集水面积 12.6km²，库容 114.5 万 m³。高板岩一级电站为坝后式电站，引水隧洞底板高程 508.73m，长度 230m，一级站尾水高程 501.96m，装机 1 台 250kW。引用流量 1.28m³/s',
  },
  3: {
    name: '高板岩二站',
    pic: 'http://172.30.100.201:8000/prd200000/upload/20231122/b3e41a65b6fd2368bc73ae781e3f0167.jpg',
    text: '高板岩二级水电站为引水式组成，总装机 500kW，主要建筑物有一座拦河大坝、隧洞、渠道、压力前池、压力钢管和厂房。高板岩二级电站引水接高板岩一级电站的尾水，通过一条长度 1250m、断面为 1.32m2 的渠道引至高板岩二级电站发电厂房',
  },
  4: {
    name: '高板岩二站',
    pic: 'http://172.30.100.201:8000/prd200000/upload/20231122/b3e41a65b6fd2368bc73ae781e3f0167.jpg',
    text: '高板岩二级电站引水接高板岩一级电站的尾水，通过一条长度 1250m、断面为 1.32m2 的渠道引至高板岩二级电站发电厂房',
  },
  5: {
    name: '高板岩二站',
    pic: 'http://172.30.100.201:8000/prd200000/upload/20231122/b3e41a65b6fd2368bc73ae781e3f0167.jpg',
    text: '水流经由压力引水管、水轮机、发电机和尾水管等，电能经发电机、断路器、升压变接入电网的过程示意',
  },
};
let timer;
export default {
  name: 'visitor',
  components: {
    Card,
  },
  data() {
    return {
      listData: [
        { code: 'runDay', name: '安全运行(天)', icon: 'icon_2_3', value: '2608' },
        { code: 'installedCapacity', name: '总装机(kW)', icon: 'icon_2_4', value: '37' },
        { code: 'powerSum', name: '总发电负荷(kW)', icon: 'icon_2_5', value: '35' },
        { code: 'planPowerMon', name: '月计划发电量(kW)', icon: 'icon_2_6', value: '28' },
        { code: 'powerMon', name: '月已发电量(kW)', icon: 'icon_2_7', value: '2839' },
        { code: 'planPowerYear', name: '年计划发电量(kW)', icon: 'icon_2_8', value: '220' },
        { code: 'powerYear', name: '年已发电量(kW)', icon: 'icon_2_9', value: '220' },
        { code: 'powerRateYear', name: '年完成率', icon: 'icon_2_10', value: '28' },
      ],
      stationInfo: {},
      renderShow: false,
      curInfo: {
        name: '',
        pic: '',
        text: '',
      },
      curShowNum: 1,
      isStartVisit: false,
    };
  },
  mounted() {
    this.stationInfo = this.$Storage.get('stationInfo');
    this.$bus.$on('isStartVisit', (data) => {
      clearInterval(timer);
      this.isStartVisit = data;
      this.renderData();
      this.startVisit();
    });
  },
  methods: {
    startVisit() {
      let count = 1;
      this.curInfo = dataConfig[count];
      count++;
      timer = setInterval(() => {
        this.curInfo = dataConfig[count];
        this.curShowNum = count;
        count++;
        if (count == 7) {
          console.log('结束参观 :>> ');
          clearInterval(timer);
        }
      }, 4500);
    },
    formartNumber(num) {
      if (num >= 10000) {
        var formattedNumber = (num / 10000).toFixed(2) + '万';
        return formattedNumber;
      } else {
        return num.toFixed(2).toString();
      }
    },
    renderData() {
      this.listData.forEach((item, index) => {
        // this.listData[index]['value'] = this.stationInfo[item.code];
        this.$set(this.listData[index], 'value', this.stationInfo[item.code]);
        console.log('this.listData[value]', this.listData);
        this.$forceUpdate();
      });
      this.renderShow = true;
    },
  },
  beforeDestroy() {
    clearInterval(timer);
  },
};
</script>

<style lang="scss" scoped>
.card_content {
  .item_list {
    flex-wrap: wrap;
    .item {
      width: 234px;
      height: 132px;
      margin-bottom: 12px;
      cursor: pointer;
      .icon {
        // margin-left: 28px;
        margin-left: 13px;
      }
      .info {
        margin-left: 15px;
        .value {
          font-size: 20px;
        }
      }
    }
  }
}
.card_visit {
  width: 480px;
  min-height: 303px;
  padding: 3px 9px;
  .view_box {
    width: 462px;
    height: 257px;
    border: 1px solid;
    border-color: rgba(36, 87, 130, 0.52);
    margin-bottom: 13px;
  }
  p {
    padding: 5px;
    &.name {
      text-align: center;
      font-size: 18px;
      letter-spacing: 2px;
      line-height: 1.5;
    }
    &.info {
      font-size: 18px;
      letter-spacing: 2px;
      line-height: 1.5;
    }
  }
  .btn_box {
    width: 462px;
    // margin-top: 13px;
    .btn {
      width: 228px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color: #fff;
      position: relative;
      cursor: pointer;
      &:nth-child(1) {
        background: linear-gradient(360deg, #ffea63 0%, rgba(192, 146, 43, 0.7) 100%);
      }
      &:nth-child(2) {
        background: linear-gradient(360deg, #56ade5 0%, rgba(45, 142, 216, 0.7) 100%);
      }
      &::before {
        content: '';
        position: absolute;
        top: -1px;
        left: -1px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 10px 10px 0 0;
        border-color: #092c51 transparent transparent transparent;
        transform: rotate(0deg);
      }
      &:active {
        opacity: 0.85;
      }
    }
  }
}
</style>
